import React from "react";

/**
 * Hero animated gold concentric waves — emanating from center.
 * Pure CSS animation, no JS. Subtle, elegant, minimal.
 */
export const HeroWaves = ({ count = 6, position = "right" }) => {
    const positionStyles =
        position === "center"
            ? { left: "50%", top: "50%" }
            : position === "left"
              ? { left: "20%", top: "50%" }
              : { left: "78%", top: "50%" };

    return (
        <div
            aria-hidden="true"
            data-testid="hero-waves"
            style={{
                position: "absolute",
                inset: 0,
                overflow: "hidden",
                pointerEvents: "none",
                zIndex: 0,
            }}
        >
            <div
                style={{
                    position: "absolute",
                    transform: "translate(-50%, -50%)",
                    width: 0,
                    height: 0,
                    ...positionStyles,
                }}
            >
                {/* Center dot */}
                <span
                    style={{
                        position: "absolute",
                        left: -4,
                        top: -4,
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        background: "#c9a227",
                        boxShadow: "0 0 18px rgba(201,162,39,0.55)",
                    }}
                />
                {/* Static faint rings as base layer */}
                {[...Array(8)].map((_, i) => {
                    const size = 120 + i * 90;
                    return (
                        <span
                            key={`s-${i}`}
                            style={{
                                position: "absolute",
                                left: -size / 2,
                                top: -size / 2,
                                width: size,
                                height: size,
                                borderRadius: "50%",
                                border: "1px solid rgba(201,162,39,0.06)",
                            }}
                        />
                    );
                })}
                {/* Animated emanating waves */}
                {[...Array(count)].map((_, i) => (
                    <span
                        key={`w-${i}`}
                        className="hero-wave"
                        style={{
                            animationDelay: `${i * (8 / count)}s`,
                        }}
                    />
                ))}
            </div>
            <div className="grain" />
        </div>
    );
};

export default HeroWaves;
